import styled from 'styled-components'

export const PasswordContent = styled.form`
  padding-top: 2.5rem;
  width: 50rem;
`
